// libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

// Components
import CardGrid from '../cardGrid/CardGrid';

// Styles
import './styles.scss';

// Props and Context
const propTypes = {
  children: PropTypes.node.isRequired,
  settings: PropTypes.object,
};
const defaultProps = {
  settings: {
    arrows: true,
    dots: false,
    slidesToShow: 3,
    infinite: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          infinite: false,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 608,
        settings: {
          slidesToShow: 1,
          infinite: false,
          arrows: false,
          dots: true,
        },
      },
    ],
  },
};
const contextTypes = {
  t: PropTypes.func,
};

function CardSlider({ children, settings }) {
  return (
    <div className="card-slider">
      <div className="grid">
        <CardGrid
          settings={settings}
          alwaysActive
        >
          {children}
        </CardGrid>
      </div>
    </div>
  );
}

CardSlider.contextTypes = contextTypes;
CardSlider.propTypes = propTypes;
CardSlider.defaultProps = defaultProps;

export default withRouter(CardSlider);



// WEBPACK FOOTER //
// ./src/app/components/cards/cardSlider/CardSlider.js